import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {LookCoBrowseIcon} from "../../../common/icons";
import COLOR_THEMES from "../../../../colorThemes";
import WithPingPilotCheck from "../../hocs/withPingPilotCheck";


const GrohePingPilotButton = (props) => {

  const {intl, topButtonClick, activeTheme, pingButton} = props;

  const pingPilotButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsPingPilot);
    topButtonClick();
    pingButton.click();
  }

  return (
    <div className={"gm-buttons__button gm-buttons__button--ping-pilot ping-pilot-visualizer-button"}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.exit"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={pingPilotButtonClick}>
        <SvgIcon>
          <LookCoBrowseIcon color={COLOR_THEMES[activeTheme].primary}/>
        </SvgIcon>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme, visualizersLoaded} = store.serverState;
  return {
    activeTheme,
    visualizersLoadedLength: visualizersLoaded.length
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WithPingPilotCheck(GrohePingPilotButton))
)
